import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
  name: 'CmgCelebrateRewardsModal',
})
export default class CmgCelebrateRewardsModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.rewardsCelebration.visible;
  }

  get bannerImageUrl(): string {
    return this.$appStore.state.cms.images.backgrounds.rewardCelebrationBanner.default;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth < ui.breakpoints.tablet;
  }

  get rewardMsg(): string {
    const args = this.$appStore.state.ui.modals.rewardsCelebration.args;
    return args ? `${args.newRewardCount} REWARD${args.newRewardCount > 1 ? 'S' : ''}` : '';
  }

  get pepperUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionReward.default;
  }

  onClose() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsNotification,
      action: AnalyticsEventAction.RewardsNotificationCloseClick,
      label: AnalyticsEventLabel.RewardsNotificationCloseClick,
    });

    this.$services.ui.setModalVisibility('rewardsCelebration', false);
    const focusNearby = document.getElementsByClassName('customer-greeting')[0] as HTMLElement;
    if (focusNearby) {
      focusNearby.focus();
    }
  }

  navigateToRewards() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsNotification,
      action: AnalyticsEventAction.RewardsNotificationMyRewardsClick,
      label: AnalyticsEventLabel.RewardsNotificationMyRewardsClick,
    });
    
    this.$router.push({ name: Routes.Rewards });
    this.onClose();
  }
}
